import React from "react";
import { Link } from "react-router-dom";
import "../styles/global.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        © {new Date().getFullYear()} Southern Homemove Ltd |{" "}
        <Link to="/privacy-policy">Privacy Policy</Link>
      </p>
    </footer>
  );
};

export default Footer;
